module.exports = "/_next/static/images/Chicago-screenshot-2-3e4c268f77fd7b6b8244791b458c7e18.png";